export enum ListWisdomUsersOrderBy {
  Forenames,
  Surname,
  Email,
  CreatedDateUtc,
  Client,
  Division,
}
